<div
  *ngIf="contacts$ | async as contacts; else loading"
  class="top-gap centered-container"
  fxLayout="column"
  fxLayoutAlign="start stretch"
  fxLayoutGap="12px"
>
  <app-no-contact-conversations *ngIf="contacts.length === 0">
  </app-no-contact-conversations>

  <app-conversation-preview
    *ngFor="let contact of contacts"
    [contact]="contact"
  ></app-conversation-preview>
</div>

<ng-template #loading>
  <app-loading-spinner
    class="results-spinner"
    [show]="true"
  ></app-loading-spinner
></ng-template>
